import React from 'react'

export default () => (
  <svg viewBox="0 0 20 14">
    <path fillRule="evenodd" clipRule="evenodd" d="M19.56 2.2A2.5 2.5 0 0017.8.43C16.24 0 10 0 10 0S3.76 0 2.2.42A2.5 2.5 0 00.44 2.2 25.72 25.72 0 000 7c-.01 1.61.13 3.217.42 4.8a2.5 2.5 0 001.78 1.77C3.76 14 10 14 10 14s6.24 0 7.8-.42a2.5 2.5 0 001.76-1.77c.297-1.586.445-3.196.44-4.81a25.73 25.73 0 00-.44-4.8zM8 10V4l5.19 3L8 10z"/>
  </svg>
)
